import React, { useEffect, useMemo } from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  List,
  ListItem,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Modification } from '../../../../contexts/MetadataContext';

interface FilterPreviewProps {
  filters: Modification[];
}

const FilterPreview: React.FC<FilterPreviewProps> = ({ filters }) => {
  if (!Object.keys(filters).length) {
    return <Typography>No filters set</Typography>;
  }

  const sortedFilters: Modification[] = useMemo(
    () =>
      filters.toSorted((a: Modification, b: Modification) => {
        if (a.match.value < b.match.value) {
          return -1;
        } else if (a.match.value > b.match.value) {
          return 1;
        }
        return 0;
      }),
    [filters],
  );

  const filtersBySet = useMemo(() => {
    const bySet: any[] = [];

    sortedFilters.forEach((filter) => {
      const setIndex = filter.match.set;
      if (bySet[setIndex]?.matchValue) {
        // set already accounted for, add to it
        const currentMatchValue = bySet[setIndex].matchValue;
        const newValue = `${currentMatchValue}, ${filter.match.value}`;
        bySet[setIndex].matchValue = newValue;
      } else {
        // new set, create it from scratch
        bySet[setIndex] = {
          matchValue: filter.match.value,
          targetValue: filter.target.value,
        };
      }
    });

    return bySet;
  }, [sortedFilters]);

  return (
    <Box>
      {filtersBySet.map((entry: any) => {
        return (
          <Accordion key={entry.matchValue}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`${entry.matchValue}-content`}
              id={`${entry.matchValue}-header`}
            >
              <Typography component="span">
                Remove from {entry.matchValue}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <List>
                {entry.targetValue?.map((lookup: string) => (
                  <ListItem key={lookup}>{lookup}</ListItem>
                ))}
              </List>
            </AccordionDetails>
          </Accordion>
        );
      })}
    </Box>
  );
};

export default React.memo(FilterPreview);
